import Styles from './SourceCard.module.scss'
import { SourceCardProps } from './Types'
import { Close } from 'almanac-ui/icons'
import { IconButton } from 'components/IconButton/IconButton'

export const SourceCard = ({ icon, title, onDismiss }: SourceCardProps) => {
  return (
    <div className={Styles.card}>
      <span className={Styles.emoji}>{icon}</span>
      <span className={Styles.title}>{title}</span>
      <IconButton size="sm" variant="tertiary" onPress={() => onDismiss()} icon={Close} />
    </div>
  )
}
